module.exports = __webpack_public_path__ + "static/img/apple-store-badge-es-CL.bbd6b5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/apple-store-badge-es-CL.png
// module id = Fz9h
// module chunks = 1